export const money = (n, opts = {}) =>
  new Intl.NumberFormat("en-CA", { style: "currency", currency: "CAD", maximumFractionDigits: 0, ...opts }).format(Number(n) || 0);

export const money2 = (n) =>
  new Intl.NumberFormat("en-CA", { style: "currency", currency: "CAD", minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(n) || 0);

export const count = (n) => new Intl.NumberFormat("en-CA").format(Number(n) || 0);

// A lead-close / conversion rate, always one decimal: 50.0%, 100.0%, 0.0%
// (SALES-033 msg_8 item 7c — one format across the table, cards, My Leads,
// the dashboard and Settings > Salespeople).
export const pct1 = (v) => `${(Number(v) || 0).toFixed(1)}%`;

// SALES-033 msg_8 item 2: a date-only string ("2026-10-02") is read by Date()
// as UTC midnight, which renders a day EARLY in a behind-UTC zone (Toronto).
// Treat a bare YYYY-MM-DD as a LOCAL calendar day so the day shown is the day
// in the string; a full timestamp is still converted normally.
export const dt = (s, opts) => {
  if (!s) return "—";
  const d = /^\d{4}-\d{2}-\d{2}$/.test(s) ? new Date(`${s}T00:00:00`) : new Date(s);
  return d.toLocaleString("en-CA", opts);
};

export const dayMonth = (s) => dt(s, { month: "short", day: "numeric" });

export const timeOnly = (s) => dt(s, { hour: "numeric", minute: "2-digit" });

// Days between now and an ISO date (negative = overdue).
export const daysUntil = (iso) => {
  if (!iso) return null;
  const then = new Date(iso).setHours(0, 0, 0, 0);
  const now = new Date().setHours(0, 0, 0, 0);
  return Math.round((then - now) / 86400000);
};

// Urgency class for a countdown in days.
export const urgencyClass = (days) => {
  if (days === null || days === undefined) return "text-muted-foreground";
  if (days < 0) return "urg-red";
  if (days <= 2) return "urg-amber";
  return "urg-green";
};
